export const downloadXlsx = (xlsxData: ArrayBuffer, fileName = 'data') => {
  const blob = new Blob([xlsxData], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  link.click();

  URL.revokeObjectURL(url);
};
